import { FunctionComponent, useEffect } from 'react';
import { useAuth } from '@sky/xerxes-client-react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import {useNavigate} from "react-router-dom";

const SignOut: FunctionComponent = () => {
  const { handleSignOutRedirect } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const delayedSignOut = setTimeout(() => {
      handleSignOutRedirect()
        .then(() => navigate('/', { replace: true }));
    }, 500);

    return () => {
      clearTimeout(delayedSignOut);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container>
      <Row>
        <Col>
          <h1>Signing Out</h1>
          <h3>Please Wait...</h3>
        </Col>
      </Row>
    </Container>
  );
};

export default SignOut;
